import React, { useState } from 'react';
import { DynamicHeight } from '../components/hooks/PageHeightCalculator';

const WelcomePage = () => {
  const [language, setLanguage] = useState('it');

  const content = {
    it: {
      title: 'Benvenuti a SoulEchoes!',
      intro: 'Se siete arrivati a questo sito é per puro caso, o perché avete ricevuto in regalo una lettera a voi stessi!',
      concept: 'Questo sito é finalmente nato dopo essere rimasto in incubazione per diverso tempo, il concetto di mandare una lettera a se stessi é qualcosa che mi ha sempre intrigato ma qualcosa mi ha sempre disturbato.',
      problem: '"Se volessi mandare una lettera a me stesso... significa che dovrei mettere da parte una lettera, ricordarmi dove questa lettera é stata messa da parte e ricordarmi di spedirla poi a me stesso." E la cosa proprio non si adatta al mio modo di fare.',
      solution: 'Diciamo che quindi questo sito é un primo passo verso la risoluzione di questo problema.',
      development: 'Sperando di arrivare molto più avanti nel suo sviluppo prima di natale, per permettervi una esperienza più completa e raffinata.',
      features: 'Le funzioni principali sono già funzionanti, se volete quindi già accedere e provarle siete liberi di farlo.',
      services: 'Ad ora una volta effettuata la registrazione, é possibile inviare a se stessi un numero infinito di email nel futuro, mentre il coupon che avete ricevuto é utilizzabile per l\'invio di una lettera fisica.',
      security: 'Tutto ciò che scriverete verrà salvato in un database criptato, e nessuno sarà in grado di leggere le vostre lettere o email fino al momento della loro apertura alla vostra porta o nella vostra casella email.',
      
      status: "Il sito è finalmente online! Buona scrittura!"
    },
    en: {
      title: 'Welcome to SoulEchoes!',
      intro: 'Whether you\'ve stumbled upon this site by chance, or because you\'ve received a gift of a letter to yourself!',
      concept: 'This site has finally come to life after being in incubation for quite some time. The concept of sending a letter to oneself is something that has always intrigued me, but something always felt off.',
      problem: '"If I wanted to send a letter to myself... it means I would have to set aside a letter, remember where I put it, and remember to send it to myself later." And that just doesn\'t fit with my way of doing things.',
      solution: 'So this site is a first step towards solving this problem.',
      development: 'We hope to make significant progress in its development before Christmas, to provide you with a more complete and refined experience.',
      features: 'The main functions are already working, so if you want to access and try them out, you\'re free to do so.',
      services: 'Currently, once registered, you can send yourself an unlimited number of future emails, while the coupon you received can be used to send one physical letter.',
      security: 'Everything you write will be saved in an encrypted database, and no one will be able to read your letters or emails until the moment they arrive at your door or in your email inbox.',
status: "The website is finally online! Enjoy writing!"
    }
  };

  const currentContent = content[language];

  return (
    <DynamicHeight className="bg-background min-h-screen">
    {/* Language switcher */}
    <div className="fixed top-4 right-4 z-10">
    <button
    onClick={() => setLanguage(language === 'it' ? 'en' : 'it')}
    className="inline-flex items-center px-3 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary shadow-lg"
    >
    {language === 'it' ? '🇬🇧 English' : '🇮🇹 Italiano'}
    </button>
    </div>
    {/* Mobile layout - Full width image at top */}
      <div className="md:hidden w-full">
        <img
          src="/images/Graphic.png"
          alt="Decorative"
          className="w-full h-64 object-cover"
        />
      </div>
    
      {/* Main content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Text content */}
          <div className="flex-1 bg-white bg-opacity-75 backdrop-blur-sm rounded-lg shadow-xl p-6">
            <h1 className="text-3xl font-bold text-gray-900 text-center mb-8">
              {currentContent.title}
            </h1>
    
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-lg font-medium">
                {currentContent.intro}
              </p>
    
              <p>
                {currentContent.concept}
              </p>
    
              <p className="italic bg-background/50 p-4 rounded-lg">
                {currentContent.problem}
              </p>
    
              <p>
                {currentContent.solution}
              </p>
    
              <p>
                {currentContent.development}
              </p>
    
              <div className="bg-primary/10 p-4 rounded-lg">
                <p className="font-medium text-gray-900">
                  {currentContent.features}
                </p>
                <p className="mt-2 text-gray-800">
                  {currentContent.services}
                </p>
              </div>
    
              <div className="bg-primary/5 p-4 rounded-lg">
                <p className="text-gray-800">
                  {currentContent.security}
                </p>
              </div>
    
              {/* New section */}
              <div className="bg-green-100 p-4 rounded-lg">
                <p className="text-green-800">
                  {currentContent.status}
                </p>
              </div>
            </div>
          </div>
    
          {/* Desktop layout - Image on right */}
          <div className="hidden md:block w-1/3">
            <div className="sticky top-8">
              <img
                src="/images/Graphic.png"
                alt="Decorative"
                className="w-full h-[600px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </DynamicHeight>
  );
};

export default WelcomePage;